import { RootState } from '../store/configureStore';

export const getCategories = (state: RootState) => state?.category?.categories;

export const isFetchingCategories = (state: RootState) =>
  state?.category?.isFetchingCategories

export const fetchingCategoriesFailed = (state: RootState) =>
  state?.category?.fetchingCategoriesFailed;
